/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { Box, Text, Flex, Divider } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function BayiContextMenu({
  position,
  data,
  onClose,
  onEdit,
  onGenelBilgiler,
}) {
  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 220, menuHeight: 170 });

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="180px"
      fontSize="11px"
      py={1}
      border="1px solid"
      borderColor="gray.200"
    >
      <MenuItem
        label="Genel Bilgiler"
        onClick={() => {
          onGenelBilgiler?.(data);
          onClose();
        }}
      />
      <Divider />
      <MenuItem
        label="Düzenle"
        onClick={() => {
          onEdit?.(data);
          onClose();
        }}
      />
    </Box>
  );
}

function MenuItem({ label, onClick, isDestructive = false }) {
  return (
    <Flex
      align="center"
      px={3}
      py={2}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{
        bg: isDestructive ? "red.50" : "blue.50",
        color: isDestructive ? "red.600" : "blue.600",
        transform: "scale(1.02)"
      }}
      onClick={onClick}
    >
      <Text fontSize="xs" fontWeight="medium" color={isDestructive ? "red.600" : "gray.700"}>
        {label}
      </Text>
    </Flex>
  );
}

export default BayiContextMenu;

